import { css } from "styled-components";

export const getButtonCss = css`
  div[id^="gb-widget"] {
    bottom: 65px !important;
    left: 25px !important;
  }
`;
